import React from "react";

interface WhatsAppAutoMessageSenderNavigationsProps {
  Settings: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  BarChart3: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  TrendingUp: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  setActiveTab: (tab: string) => void;
  activeTab: string;
}

export const WhatsAppAutoMessageSenderNavigations: React.FC<
  WhatsAppAutoMessageSenderNavigationsProps
> = ({ Settings, BarChart3, TrendingUp, setActiveTab, activeTab }) => {
  return (
    <div className="flex items-center justify-between mb-8">
      <div className="flex gap-2">
        {[
          { id: "Campaignes", label: "Campaignes", icon: TrendingUp },
          {
            id: "Interal Auto Sender",
            label: "Interal Auto Sender",
            icon: Settings,
          },
          { id: "dashboard", label: "Dashboard", icon: BarChart3 },
        ].map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all duration-200 text-sm ${
              activeTab === tab.id
                ? "bg-white text-blue-600 shadow-lg border-2 border-blue-200"
                : "text-gray-600 hover:text-gray-900 hover:bg-white/50"
            }`}
          >
            <tab.icon className="w-4 h-4" />
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};
